import ClerkAuthSessionProvider from "@/components/common/clerk-auth-session-provider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import { PermissionProvider } from "./permission-context";

const queryClient = new QueryClient();

// App-wide providers. The sidebar + region-aware shell now live in RegionLayout
// (under the /:region route) so they can read the region from the URL.
export default function AppRouterProviders() {
  return (
    <QueryClientProvider client={queryClient}>
      <ClerkAuthSessionProvider>
        <PermissionProvider>
          <Outlet />
        </PermissionProvider>
      </ClerkAuthSessionProvider>
    </QueryClientProvider>
  );
}
